module.exports = __webpack_public_path__ + "img/Constant Learner.ff63e9e6.svg";